import { Button, ButtonProps, Menu } from '@mantine/core';
import { IconCirclePlus, IconUserPlus, IconUsers } from '@tabler/icons-react';
import { useClientsContext } from '../../clients/context/ClientsContext';
import CreateClientModal from '../../clients/CreateClientModal';
import CreateFamilyFlow from '../../clients/CreateFamily/CreateFamilyFlow';
import EditFamilyFlow from '../../clients/CreateFamily/EditFamilyFlow';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import { useUsersContext } from 'src/admin/users/context/UsersContext';
import CreateUserModal from 'src/admin/users/components/CreateUserModal';

export function CreateButton({ buttonProps }: { buttonProps?: ButtonProps }) {
  const { isSystemAdmin } = useCurrentUser();
  const { flow, clientPrefill, startClientCreation, startFamilyCreation, close } =
    useClientsContext();
  const { flow: usersFlow, close: usersClose } = useUsersContext();

  return (
    <>
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <Button variant="primary" leftSection={<IconCirclePlus size={20} />} {...buttonProps}>
            Create new
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          {/*{isSystemAdmin && (*/}
          {/*  <Menu.Item leftSection={<IconUserPlus size={16} />} onClick={startUserCreation}>*/}
          {/*    User*/}
          {/*  </Menu.Item>*/}
          {/*)}*/}

          <Menu.Item leftSection={<IconUserPlus size={16} />} onClick={() => startClientCreation()}>
            Client
          </Menu.Item>

          <Menu.Item leftSection={<IconUsers size={16} />} onClick={startFamilyCreation}>
            Family
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <CreateClientModal opened={flow === 'client'} close={close} prefill={clientPrefill} />

      {isSystemAdmin && <CreateUserModal opened={usersFlow === 'create-user'} close={usersClose} />}

      <CreateFamilyFlow />

      <EditFamilyFlow />
    </>
  );
}
